"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stitch = stitch;
exports.dedupe = dedupe;
exports.revlist = revlist;
exports.calculateUTRs = calculateUTRs;
exports.ellipses = ellipses;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function stitch(subfeats, sequence) {
  return subfeats.map(function (sub) {
    return sequence.slice(sub.start, sub.end);
  }).join('');
} // filter items if they have the same "ID" or location


function getItemId(feat) {
  return "".concat(feat.start, "-").concat(feat.end);
} // filters if successive elements share same start/end


function dedupe(list) {
  return list.filter(function (item, pos, ary) {
    return !pos || getItemId(item) !== getItemId(ary[pos - 1]);
  });
}

function revlist(list, seqlen) {
  return list.map(function (sub) {
    return _objectSpread(_objectSpread({}, sub), {}, {
      start: seqlen - sub.end,
      end: seqlen - sub.start
    });
  }).sort(function (a, b) {
    return a.start - b.start;
  });
} // calculates UTRs using impliedUTRs logic


function calculateUTRs(cds, exons) {
  var firstCds = cds[0];
  var lastCds = cds[cds.length - 1];
  var firstCdsIdx = exons.findIndex(function (exon) {
    return exon.end >= firstCds.start && exon.start <= firstCds.start;
  });
  var lastCdsIdx = exons.findIndex(function (exon) {
    return exon.end >= lastCds.end && exon.start <= lastCds.end;
  });
  var lastCdsExon = exons[lastCdsIdx];
  var firstCdsExon = exons[firstCdsIdx];
  var fiveUTRs = [].concat((0, _toConsumableArray2.default)(exons.slice(0, firstCdsIdx)), [{
    start: firstCdsExon.start,
    end: firstCds.start
  }]).map(function (elt) {
    return _objectSpread(_objectSpread({}, elt), {}, {
      type: 'five_prime_UTR'
    });
  });
  var threeUTRs = [{
    start: lastCds.end,
    end: lastCdsExon.end
  }].concat((0, _toConsumableArray2.default)(exons.slice(lastCdsIdx + 1))).map(function (elt) {
    return _objectSpread(_objectSpread({}, elt), {}, {
      type: 'three_prime_UTR'
    });
  });
  return [].concat((0, _toConsumableArray2.default)(fiveUTRs), (0, _toConsumableArray2.default)(threeUTRs));
}

function ellipses(slug) {
  return slug.length > 20 ? "".concat(slug.slice(0, 20), "...") : slug;
}